Trafiken.HashQuery = (function () {
    var instance;
    var coords;
    var zoom;
    var queryStringObject = {};

    // Sanitize keys to prevent prototype pollution
    function sanitizeKey(key) {
        return '$' + key;
    }

    // Unsanitize keys for external use
    function unsanitizeKey(key) {
        return key.startsWith('$') ? key.substring(1) : key;
    }

    function pullQuery() {
        var hash = window && window.location.hash.split('#')[1]
        var queryString;
        if (!hash) {
            queryStringObject = {};
            return;
        }
        if (hash.indexOf('?') === -1) {
            queryString = /^[^\d]/.test(hash) ? hash : null;
        } else {
            queryString = hash.split('?')[1];
        }

        if (!queryString) {
            queryStringObject = {};
            return;
        }

        queryStringObject = queryString.split('&')
            .reduce(function(params, param) {
                var key = param.split('=')[0];
                var value = param.split('=')[1];
                params[sanitizeKey(key)] = value ? decodeURIComponent(value) : '';
                return params;
            }, {}
            );
    }

    function updateHash(addHistory) {
        var newMapPosition = coords && zoom && coords.concat([zoom]).join(',');
        var newQueryString = queryStringObject &&
            Object.keys(queryStringObject)
            .map(function (k) {
                var unsanitizedKey = unsanitizeKey(k);
                return encodeURIComponent(unsanitizedKey) + (queryStringObject[k] ? '=' + encodeURIComponent(queryStringObject[k]) : '')
            }).join('&');
        var newHash =
            (newMapPosition || newQueryString ? '#' +
                (newMapPosition || '') +
                (newMapPosition && newQueryString ? '?' : '') +
                (newQueryString || '')
                : window.location.pathname + window.location.search);
        window.history[addHistory ? 'pushState' : 'replaceState'](null, null, newHash);
    }

    return {
        getQueryAsObject: function () {
            pullQuery();
            // Return a new object with unsanitized keys
            var result = {};
            for (var key in queryStringObject) {
                if (queryStringObject.hasOwnProperty(key)) {
                    var cleanKey = key.startsWith('$') ? unsanitizeKey(key) : key;
                    result[cleanKey] = queryStringObject[key];
                }
            }
            return result;
        },

        getQueryByKey: function (key) {
            pullQuery();
            var sanitized = sanitizeKey(key);
            // Try sanitized key first, fallback to unsanitized for backward compatibility
            return queryStringObject && (queryStringObject[sanitized] !== undefined 
                ? queryStringObject[sanitized] 
                : queryStringObject[key]);
        },

        hasQueryKey: function (key) {
            pullQuery();
            // Check sanitized key first, fallback to unsanitized for backward compatibility
            return queryStringObject && (queryStringObject.hasOwnProperty(sanitizeKey(key)) 
                || queryStringObject.hasOwnProperty(key));
        },

        setQueryValue: function (key, value, addHistory) {
            pullQuery();
            queryStringObject[sanitizeKey(key)] = value;
            updateHash(addHistory);
        },

        removeQueryKey: function (key, addHistory) {
            pullQuery();
            delete queryStringObject[sanitizeKey(key)];
            updateHash(addHistory);
        }
    }
})();
